import { Plugin } from '@nuxt/types'

import { initializeModules } from '@/utils/store-init'

const storePlugin: Plugin = ({ store, $axios }) => {
  initializeModules(store, $axios)
}

export default storePlugin
